"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "mansue": {
    "18719c61": [{
      "hkey": "732c4498",
      "slug": "basalghelle-cornare",
      "name": "Basalghelle-Cornarè",
      "primary": true,
      "skipSearch": false
    }],
    "basalghelle": [{
      "hkey": "732c4498",
      "slug": "basalghelle-cornare",
      "name": "Basalghelle-Cornarè",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;